import React from 'react';
import './EmptyTodos.css';

function EmptyTodos() {
  return (
    <p className='EmptyTodos'>You have not created any task yet</p>
  );
}

export { EmptyTodos };